import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ButtonModule } from '@components/button/button.module';
import { HeaderDesktopComponent } from './header-desktop.component';
import { HeaderMenuModule } from '@components/header-menu/header-menu.module';
import { ButtonGroupModule } from '@components/button-group/button-group.module';


@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ButtonModule,
    HeaderMenuModule,
    ButtonGroupModule
  ],
  declarations: [HeaderDesktopComponent],
  exports: [HeaderDesktopComponent]
})
export class HeaderDesktopModule {}
